import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import auth from './modules/auth';
import topup from './modules/topup';

Vue.use(Vuex);

// noinspection JSValidateTypes
const store = new Vuex.Store({
  modules: {
    app,
    auth,
    topup,
  },
  strict: true,
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js